import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import {ApiCode} from "@/const/api";

export default {
    async getData(params) {
        try {
            const response = await axios.get(`certificates/certificate_blank_status`, {params})
            const { data } = response
            return data.data
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
    async delete(id) {
        try {
            const response = await axios.delete(`certificates/certificate_blank_status/${id}`)
            const { data } = response
            return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
    async update(params){
        try {
            const response = await axios.put(`certificates/certificate_blank_status/${params.id}`, params)
            const { data } = response
            return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
    async save(params){
        try {
            const response = await axios.post('certificates/certificate_blank_status', params)
            const { data } = response
            return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
}
